import {ProductBadge} from '@/__generated__/__types__';

export interface BadgeTypeMock {
    id: number;
    name: string;
    is_active: boolean;
    position: number;
    image: string;
    start_date: string;
    end_date: string;
    description: string;
}

export const highestPriorityBadgeActive = (productBadgeList: ProductBadge[]) => {
    const currentDate = Date.now();

    const activeBadge = productBadgeList.filter(badge => {
        if (!badge?.is_active) return false;

        const startTime = badge.start_date ? new Date(badge.start_date).getTime() : 0;
        const endTime = badge.end_date ? new Date(badge.end_date).getTime() : Infinity;

        if (Number.isNaN(startTime) || Number.isNaN(endTime)) return false;

        return currentDate >= startTime && currentDate <= endTime;
    });

    const sortedBadge = [...activeBadge].sort((a, b) => (b.position ?? 0) - (a.position ?? 0));

    return sortedBadge.at(0);
};
